import { useMutation } from "@tanstack/react-query";
import { getRegisterHostProfile, getUserOnboardingStatus } from "@onair/services/host";

export const useMutationGetUserOnboardingStatus = () => {
	return useMutation({
		mutationFn: (email: string) => getUserOnboardingStatus(email),
	});
};

export const useMutationGetRegisterHostProfile = () => {
	return useMutation({
		mutationFn: (email: string) => getRegisterHostProfile(email),
	});
};
